import * as React from 'react';
import { translation } from '../../../i18n';
import { AnsweredModule, AnsweredQuestionnaireDto } from '../../../pages/answeredQuestionnaireTypes';
import AnsweredQuestionModule from './AnsweredQuestionModule';
import Catalogue from '../common/Catalogue';

interface Props {
  answeredModules: AnsweredModule[],
  questionnaireId: number,
  enableComment: boolean,
  updateQuestionnaire: (updatedQuestionnaire: AnsweredQuestionnaireDto) => void
}

class AnsweredQuestionCatalogue extends React.Component<Props> {

  constructor(props: Props) {
    super(props);
    this.renderModule = this.renderModule.bind(this);
  }

  public render() {
    return (
      <Catalogue
        modules={this.props.answeredModules}
        renderModule={this.renderModule}
        finishPage={{
          head: translation.t('answeredQuestionCatalogueComponent.title'),
          body: translation.t('answeredQuestionCatalogueComponent.body')
        }}
      />
    )
  }

  private renderModule(activeStep: number) {
        return (
          <AnsweredQuestionModule key={this.props.answeredModules[activeStep].id}
                                  updateQuestionnaire={this.props.updateQuestionnaire}
                                  enableComment={this.props.enableComment}
                                  answeredModule={this.props.answeredModules[activeStep]}
                                  questionnaireId={this.props.questionnaireId}
          />
        )
  }

}

export default AnsweredQuestionCatalogue;

